<template>
  <header class="py-2 bg-white">
    <div class="container">
      <div class="row">
        <div class="col-auto mx-auto">
          <img src="@/assets/img/logo.png" alt="dawoods" height="60" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {};
</script>

<style>
</style>